export const PHONE_REGEXP =
  /^((\+[1-9]{1,4}[ -]*)|(\([0-9]{2,3}\)[ -]*)|([0-9]{2,4})[ -]*)*?[0-9]{3,4}?[ -]*[0-9]{3,4}?$/;

export const DEFAULT_USER_DATA = {
  fullname: "",
  email: "",
  password: "",
  country: "",
  state: "",
  city: "",
  dob: "",
  gender: "",
  imageUrl: "",
  coverUrl: "",
  phonenumber: "",
  description: { text: "Add your description", privacy: "private" },
  contactNumber: { text: "", privacy: "public" },
  address: { text: "", privacy: "friends" },
  bio: { text: "Add Your Bio", privacy: "public" },
  education: [
    { text: "Add University", privacy: "private", degree: "primary" },
    { text: "Add Higher Education", privacy: "public", degree: "higher" },
  ],
  isVerified: false,
  status: true,
};

export const PLACEHOLDER_EDUCATION = ["Add University", "Add Higher Education"];
